import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 140px;
  border: 1px solid var(--color-white);
  border-radius: var(--border-radius8);
  background: var(--color-greyEC);
  outline: none;
  overflow: hidden;
  cursor: pointer;
  &:disabled {
    border: 1px solid var(--color-white);
    cursor: not-allowed;
  }
  &:focus {
    box-shadow: var(--shadow-focus);
  }
  @media (hover) {
    &:hover {
      border: 1px solid var(--color-grey97);
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const DragBox = styled(motion.div)`
  display: none;
  position: fixed;
  background: var(--color-greyEC);
  background-image: url(${({ $src }) => $src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: var(--border-radius8);
  border: 1px solid var(--color-white);
  cursor: grabbing;
  z-index: 100;
`;
